import React, { useState, useEffect } from "react";
import { FormGroup, Input, Button, Form, Spinner, Row, Col } from "reactstrap";
import Dataservices from "../../services/requestApi";
import { Image, message } from "antd";
import Resizer from "react-image-file-resizer";

// Text editor
import TextEditor from "components/TextEditor";
import { useHistory } from "react-router-dom";

const EditProduct = ({ Allcategory, editdata, allBrand }) => {
  const [category, setCategoryId] = useState("");
  const [name, setName] = useState("");
  const [hsm, setHsm] = useState("");
  const [gst, setGst] = useState(0);
  const [product_code, setProductCode] = useState("");
  const [type, setType] = useState("");
  const [material, setMaterial] = useState("");
  const [mrp, setMrp] = useState(0);
  const [price, setPrice] = useState("");
  const [brand, setBrand] = useState("");
  const [slug, setSlug] = useState("");
  const [image, setImage] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [description, setDescription] = useState("");
  const [shortdescription, setShortDescription] = useState("");
  const [ready, setReady] = useState(false);
  const [productid, setProductId] = useState("");
  const [COD, setCod] = useState(false);
  const [replacement, setReplacement] = useState(false);
  const [FOD, setFod] = useState(false);
  const [Quantity, setQuantity] = useState(0);

  // Update Current Data
  const data = editdata.state;
  let history = useHistory();
  useEffect(() => {
    // console.log(data);
    if (!data) return;
    if (data) {
      console.log(data);
      setCategoryId(data.category);
      setName(data.name);
      setType(data.type);
      setFod(data.FOD);
      setHsm(data.hsm);
      setGst(data?.gst ?? 0);
      setProductCode(data.product_code);
      setQuantity(data.quantity);
      setMaterial(data.material);
      setBrand(data.brand_id);
      setSlug(data.slug);
      setImage(data.image);
      setMrp(data.mrp ?? 0);
      setPrice(data.price);
      setDescription(data.description);
      setShortDescription(data.short_description);
      setProductId(data._id);
      setReplacement(data.Replacement);
      setCod(data.COD);
    }
  }, [data]);

  const UpdateProduct = async (e) => {
    e.preventDefault();
    setReady(true);
    const data = new FormData();
    data.append("name", name);
    data.append("slug", slug);
    data.append("type", type);
    data.append("Replacement", replacement);
    data.append("COD", COD);
    data.append("hsm", hsm);
    data.append("gst", gst);
    data.append("product_code", product_code);
    data.append("material", material);
    data.append("FOD", FOD);
    data.append("quantity", Quantity);
    if (type === "single" || type === "multiple") {
      data.append("mrp", mrp ?? 0);
      data.append("price", price);
    }
    data.append("category", category);
    data.append("brand_id", brand);
    image.forEach((element) => {
      console.log(element);
      if (element?.image_link) {
        data.append("prev_image", element?.image_link);
      } else {
        data.append("image", element);
      }
    });
    data.append("description", description);
    data.append("short_description", shortdescription);
    try {
      const res = await Dataservices.ProductUpdate(productid, data);
      console.log(res.data);
      if (res.data?.status_code === 200) {
        setReady(false);
        history.goBack();
      } else {
        message.error("Something Went Wrong");
      }
    } catch (e) {
      console.log(e.response.data);
      if (e.response.data) {
        message.success(e.response.data.message);
        setReady(false);
      }
    }
  };

  const fileHandler = (e) => {
    const file = [...e.target.files];
    if (file) {
      setImage([]);
      setThumbnail([]);
      file.forEach((file) => {
        Resizer.imageFileResizer(
          file,
          500,
          500,
          "JPEG",
          90,
          0,
          (uri) => {
            setImage((prev) => [...prev, uri]);
            setThumbnail((prev) => [...prev, uri]);
          },
          "file",
          500,
          500
        );
      });
    } else {
      setImage(null);
      setThumbnail(null);
    }
  };
  const HandleName = (e) => {
    let text = e.target.value;
    const slugtext = text.toLocaleLowerCase().replaceAll(" ", "-");
    setName(text);
    setSlug(slugtext);
  };
  return (
    <>
      <Form role="form" onSubmit={UpdateProduct} encType="multipart/form-data">
        <Row>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Brand
              </label>
              <Input
                type="select"
                id="paid"
                value={brand}
                className="form-control-alternative"
                onChange={(e) => setBrand(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                {allBrand?.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}{" "}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Product Type
              </label>
              <Input
                type="select"
                id="paid"
                value={type}
                className="form-control-alternative"
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value="single">Single </option>
                <option value="multiple">Multiple</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Select Category
              </label>
              <Input
                type="select"
                id="paid"
                value={category}
                className="form-control-alternative"
                onChange={(e) => setCategoryId(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                {Allcategory &&
                  Allcategory.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.category}{" "}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Cash on Delivery
              </label>
              <Input
                type="select"
                id="paid"
                className="form-control-alternative"
                onChange={(e) => setCod(e.target.value)}
                value={COD}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                7 Days replacement
              </label>
              <Input
                type="select"
                id="paid"
                value={replacement}
                className="form-control-alternative"
                onChange={(e) => setReplacement(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Free Delivery
              </label>
              <Input
                type="select"
                id="paid"
                value={FOD}
                className="form-control-alternative"
                onChange={(e) => setFod(e.target.value)}
                required
              >
                <option value="">Select ... </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="paid">
                Quantity
              </label>
              <Input
                type="number"
                value={Quantity}
                className="form-control-alternative"
                onChange={(e) => setQuantity(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label" htmlFor="name">
                Name
              </label>
              <Input
                className="form-control-alternative"
                id="name"
                placeholder="Name"
                type="text"
                value={name}
                onChange={HandleName}
              />
            </FormGroup>
          </Col>
          {type && (
            <>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label" htmlFor="Brand">
                    Mrp
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="Brand"
                    placeholder="Enter Mrp"
                    type="number"
                    value={mrp}
                    onChange={(e) => setMrp(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label" htmlFor="Brand">
                    Price
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="Brand"
                    placeholder="Enter Price"
                    type="text"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </>
          )}
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="hsn">
                HSN
              </label>
              <Input
                type="text"
                id="hsn"
                placeholder="Enter HSN"
                className="form-control-alternative"
                value={hsm}
                onChange={(e) => setHsm(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label
                className="form-control-label d-block"
                htmlFor="product_code"
              >
                Product Code
              </label>
              <Input
                type="text"
                id="product_code"
                value={product_code}
                placeholder="Enter Product code"
                className="form-control-alternative"
                onChange={(e) => setProductCode(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col lg="4">
            <FormGroup>
              <label className="form-control-label d-block" htmlFor="gst">
                GST (%)
              </label>
              <Input
                type="number"
                id="gst"
                value={gst}
                placeholder="Enter Gst"
                className="form-control-alternative"
                onChange={(e) => setGst(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <label className="form-control-label" htmlFor="image">
            Image
          </label>
          <Input
            className="form-control-alternative"
            id="image"
            type="file"
            accept="image/*"
            onChange={fileHandler}
            multiple
          />
          {!thumbnail &&
            data &&
            data.image.map((img) => (
              <Image
                width={200}
                src={`${img?.image_link}`}
                key={img?._id}
                className="mt-3"
              />
            ))}
          {thumbnail &&
            thumbnail.map((item) => (
              <Image
                width={200}
                src={URL.createObjectURL(item)}
                className="mt-3"
              />
            ))}{" "}
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="Brand">
            Material
          </label>
          <Input
            className="form-control-alternative"
            id="Brand"
            placeholder="Enter Material"
            type="text"
            value={material}
            onChange={(e) => setMaterial(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="short_des">
            Short Description
          </label>
          <Input
            className="form-control-alternative"
            id="short_des"
            placeholder="Enter Short Description"
            type="textarea"
            rows="4"
            value={shortdescription}
            onChange={(e) => setShortDescription(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="desc">
            Description
          </label>
          <TextEditor value={description} setvalue={setDescription} />
        </FormGroup>
        <Button
          className="my-4 btn-block"
          type="submit"
          color="warning"
          disabled={ready}
        >
          {ready && <Spinner size="sm" color="light" />} Update Product
        </Button>
      </Form>
    </>
  );
};
export default EditProduct;
